import { render, staticRenderFns } from "./DateUpdate.vue?vue&type=template&id=4b74f54c"
import script from "./DateUpdate.vue?vue&type=script&lang=js"
export * from "./DateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports